import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import $ from 'jquery';
import ApiURl from '../controllers/Api';

const ProtectedRoute = ({ element: Element, adminOnly = false }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');
  const sendToken = token ? `Bearer ${token}` : '';

  const clearAuthState = () => {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('user_id');
    localStorage.removeItem('phone');
    localStorage.removeItem('cart_id');
    localStorage.removeItem('userData');
    window.dispatchEvent(new Event('authChanged'));
  };

  useEffect(() => {
    let cancelled = false;

    const validateToken = () => {
      if (!token) {
        clearAuthState();
        if (!cancelled) {
          setIsAuthenticated(false);
        }
        return;
      }

      $.ajax({
        url: `${ApiURl}/auth.php`,
        method: 'GET',
        data: {
          token: sendToken,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .done((response) => {
          if (cancelled) return;

          if (response?.success) {
            setIsAuthenticated(true);
            return;
          }

          clearAuthState();
          setIsAuthenticated(false);
        })
        .fail(() => {
          if (cancelled) return;

          clearAuthState();
          setIsAuthenticated(false);
        });
    };

    validateToken();
    const intervalId = setInterval(validateToken, 15000);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
    };
  }, [token, sendToken]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  if ((userRole || '').toLowerCase() !== 'admin' && adminOnly) {
    return <Navigate to="/unauthorized" />;
  }

  return isAuthenticated ? <Element /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
